import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import * as q from 'qs';
import { weappSDK } from '../sdk';
import { ua } from '../ua';
import weappMonitorInstance from '../monitor';
import { getHash } from '../monitor/utils';
import corsImport from '../corsImport';
import { doSensitiveScan, replaceSensitiveData } from './sensitiveScan';
import { AnyObj } from '../moduleRouter/types';
import { getLabel } from '../locale';
import { sessionTraceId } from "./sessionTraceId";
import { getSyncHook } from '../js-api-tools';

// axios.defaults.timeout = 10000;
// axios.defaults.baseURL = window.publicUrlapi || window.publicUrl || '';

axios.interceptors.request.use(function (config: any) {
  config.headers.timeZoneOffset = new Date().getTimezoneOffset();
  return config;
});

axios.interceptors.request.use(function (config: any) {
  // url绑定weappmonitor_traceId,支持前后端链路
  const traceIdSwitchStatus: boolean = localStorage.getItem('weappMonitorTraceIdSwitchStatus') === 'true' ? true : false;

  // 天梭监控数据上报标识，对应监控小工具的“测试流量”
  if (localStorage.getItem('testFlowStatus') && localStorage.getItem('testFlowStatus') == '3') {
    config.headers.t = 3
  }
  if (traceIdSwitchStatus) {
    // header 增加traceId,性能上报的时候提交到perf数据中 (随机数_时间搓：防止重复)
    const traceId = `${getHash(10)}_${new Date().getTime()}`;
    config.headers.traceid = traceId; // header 均为 小写
    const requestUrl = config.url?.trim?.();
    if (requestUrl) {
      const idx = requestUrl.indexOf('?');
      if(idx > -1) {
        const splitArr = requestUrl.split('?');
        const requestUrlparams = q.parse(splitArr[1]);
        requestUrlparams['weappmonitor_traceId'] = traceId;
        config.url = `${splitArr[0]}?${q.stringify(requestUrlparams)}`;
      } else {
        config.url = `${requestUrl}?weappmonitor_traceId=${traceId}`;
      }
    }
  }

  const localeEteamsId = window.ETEAMSID || window.localStorage?.getItem?.('E10_ETEAMSID_LOCAL');
  if (localeEteamsId) {
    // 非 （配置白名单 + 请求地址包含域名 + 当前域名不在白名单内）的情况，传递eteamsid
    if (!
      (
        window.TEAMS?.weappDomains &&
        config.url?.match(/^((http:\/\/)|(https:\/\/))/) &&
        !window.TEAMS?.weappDomains?.find((dommainName: any) => config.url?.match(dommainName))
      )
     ) {
      config.headers.eteamsid = localeEteamsId;
    }
  }
  return config;
});
export interface CacheQueue {
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
};

export interface CacheData {
  time: number;
  total: number;
  queue: CacheQueue[];
}

export interface Instance {
  time: number;
  [key: number]: CacheData
}

export interface Cache {
  [key: string]: Instance
};

// 重复请求缓存与取消
// const CancelToken = axios.CancelToken;
// const source = CancelToken.source();
const cache: Cache = {};
function getRequestCacheKey(options: RequestOptionConfig) {
  const method: string = (options?.method || '').toLowerCase() || 'get';
  const params: string = JSON.stringify(options?.params || '');
  const returnSourceData = options?.returnSourceData || 'false';
  return `${options.url || ''}${method}${options?.data || ''}${params}${returnSourceData}`;
}
function clearCacheQueue(
  cacheRequestKey: string,
  r: any,
  a: 'resolve' | 'reject',
  options: RequestOptionConfig,
  time: number
) {
  let result = r;
  let action = a;
  // 重复请求结果正常被取消
  if (options.cancelLimit && a === 'resolve') {
    result = {
      message: 'Repeated request canceled.',
      config: r.config,
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      response:r
    }
    action = 'reject';
  }
  if (action === 'resolve') {
    result = r.data;
  }

  if (options?.returnSourceData) {
    result = r;
  }

  if (cache[cacheRequestKey] && cache[cacheRequestKey][time]) {
    while(cache[cacheRequestKey][time].queue.length) {
      cache[cacheRequestKey][time].queue[0][action](result);
      cache[cacheRequestKey][time].queue.shift();
    }
    let clear = 0;
    const timer = setInterval(() => {
      if (clear > 4) {
        clearInterval(timer);
        delete cache[cacheRequestKey][time];
        if (Object.keys(cache[cacheRequestKey]).length === 1 && cache[cacheRequestKey].hasOwnProperty('time')) {
          delete cache[cacheRequestKey]
        }
      } else {
        if (cache[cacheRequestKey][time].queue.length === 0) {
          clear ++;
        }
        while(cache[cacheRequestKey][time].queue.length) {
          cache[cacheRequestKey][time].queue[0][action](result);
          cache[cacheRequestKey][time].queue.shift();
        }
      }
    }, 100);
  }
}

function getErrMessage(response: AxiosResponse) {
  let message: string = '';
  switch (response.status) {
    case 400:
      message = getLabel('184761','请求错误')
      break
    case 401:
      message = getLabel('184762','未授权，请登录')
      break
    case 403:
      message = getLabel('184763','拒绝访问')
      break
    case 404:
      message = `${getLabel('184764','请求地址出错')}: ${response.config.url}`
      break
    case 408:
      message = getLabel('184765','请求超时')
      break
    case 500:
      message = getLabel('184766','服务器内部错误')
      break
    case 501:
      message = getLabel('184767','服务未实现')
      break
    case 502:
      message = getLabel('184768','网关错误')
      break
    case 503:
      message = getLabel('184769','服务不可用')
      break
    case 504:
      message = getLabel('184770','网关超时')
      break
    case 505:
      message = getLabel('184771','HTTP版本不受支持')
      break
    default:
  }
  return message;
}

function errMessage(message: string) {
  // 防止消息为空时也触发提示
  if (!message) return;
  if (window.weappUi) {
    if (window.weappUi.Dialog) {
      window.weappUi.Dialog.message({
        type: 'error',
        content: message,
      });
    } else if (window.weappUi.default && window.weappUi.default.Dialog) {
      window.weappUi.default.Dialog.message({
        type: 'error',
        content: message,
      });
    }
  }
}

// 需要显示错误提示信息的模块
const showErrMsgModules = [
  'dw',
  'escheduler-admin',
];

// 判断该api是否需要显示错误提示信息
function isShowErrMsg (url: string) {
  let flag = false;
  const lsShowErrMsg = window.localStorage?.getItem('showErrMsgModules') || '';
  let showErrMsgModulesNow = showErrMsgModules;
  if (lsShowErrMsg) {
    showErrMsgModulesNow = showErrMsgModulesNow.concat(lsShowErrMsg.split(','));
  }
  for (let i = 0; i < showErrMsgModulesNow.length; i ++) {
    const module = showErrMsgModulesNow[i];
    /**
     * 处理一下几种类型的api:
     * 1. /api/{module}/**
     * 2. /api/app/{module}/**
     * 3. /papi/api/{module}/**
     * 4. /papi/api/app/{module}/**
     */
    const patt = new RegExp(`^\\/p?api(\\/app)?\\/${module}\\/[^\\/]+`);
    flag = patt.test(url);
    if (flag) {
      break;
    }
  }
  return flag;
}

// 处理license未授权
function handleLisenceError (msg: string, devOpsUrl?: string) {
  const Icon = window.weappUi?.Icon;
  const Empty = window.weappUi?.Empty;
  const image = (<Icon name="Icon-empty-No-permission" style={{ width: 150, height: 150 }} />);

  const description = devOpsUrl
    ? <a className="no-license-empty-link" href={devOpsUrl}>{msg}</a>
    : <span className="no-license-empty-span">{msg}</span>;

  ReactDOM.render(
    (<div className="no-license-empty-wrap">
      <Empty className="no-license-empty" image={image} description={description} />
    </div>),
    document.getElementById('root')
  );
}

/**
 * @param {string} url 请求地址
 *
 * @description 匹配 url 数据格式，并从 url 中获取模块标识
 *
 * API 匹配规则： /^\/p?api(\/app)?(\/bs)?\/[^/?]+/
 *
 * 示例：
 *
 * '/api/bs/test?v=1' => 'test'
 *
 * '/api/app/bs/test?v=1' => 'test'
 *
 * '/papi/bs/test?v=1' => 'test'
 *
 * '/papi/app/bs/test?v=1' => 'test'
 *
 * '/api/task/test?v=1' => 'task'
 *
 * '/api/app/task/test?v=1' => 'task'
 *
 * '/papi/task/test?v=1' => 'task'
 *
 * '/papi/app/task/test?v=1' => 'task'
 */
export function getNameFromUrl (url: string) {
  let name: string = '';

  const matchUrl: any = url.match(/^\/p?api(\/app)?(\/bs)?\/[^/?]+/);
  if (matchUrl) { // eslint-disable-line
    // 截取 api 中模块的标识，只能处理一级标识
    name = matchUrl[0].replace(/^\/p?api(\/app)?(\/bs)?\//, () => '');
  }
  return name;
}

// 计算 api 前缀
export function getBaseUrl (url: string) {
  const name = getNameFromUrl(url);
  if (name) {
    const baseURL: string = window[`apiUrlweapp${name}`] || window.publicUrlapi || window.publicUrl || ''; // 处理二级路径
    const baseDomain: string = window[`apiDomainweapp${name}`] || window['publicDomainapi'] || ''; // 处理二级域名
    return `${baseDomain}${baseURL}`;
  }
  return '';
}

// 接口二级路径变量规则
export function prefixSecondPath (url: string) {
  const baseUrl = getBaseUrl(url);
  return `${baseUrl}${url}`;
}

export interface RequestOptionConfig extends AxiosRequestConfig {
  /* 设置接口错误时不走默认的报错处理 */
  customHandleError?: boolean;
  /* 设置重复请求取消设置 */
  cancelLimit?: boolean;
  /* 缓存 request 请求的 key 值 */
  cacheRequestKey?: string;
  /* 是否将请求结果res整个对象返回 而不是返回res.data 默认为false*/
  returnSourceData?: boolean;
};

export type RequestResult<T = any> = {
  code: number;
  status: boolean;
  msg: string;
  data: T;
  actionMsg?: {
    code?: number;
    message?: string;
  };
  result?: boolean;
  devOpsUrl?: string;
  _securityIntercept_?: string; // 安全拦截标识
};

export type RequestPromise<T = any> = Promise<RequestResult<T>>;

function doLogout (){
  // 登录超时处理
  try {
    if (window?.ePassport?.isFreePassUrl) {
      // 如果是免登地址 不做任何操作
    } else if (ua.device === 'PC') {   // pc端：调用主框架的 relogin 方法
      if (window?.TEAMS?.disableTimeoutLoginBox) {
        // 当 TEAMS.disableTimeoutLoginBox 为 true 时不显示重登弹框，直接调用 window.ePassport.logout() 跳转到登录页面
        window?.ePassport?.logout?.();
      } else {
        if (window?.weappLayout?.relogin) {
          window.weappLayout.relogin();
        } else {
          corsImport("@weapp/layout").then(module=>{    
            module?.relogin();
          })
        }
      }
    } else if (ua.browser === 'Weapp') {  // App：调用sdk的logout方法
      weappSDK.exec('logout', {
        tip: getLabel('184772','登录超时，请重新登录'),
      });
    } else {
      if (['MicroMessenger', 'wxwork'].indexOf(ua.browser) === -1) { // 非免登录第三方的H5页面：跳转到登录页
        window?.ePassport?.logout?.();
      } else {
        // 免登录的第三方：不做处理
      }
    }
  } catch(e) {
    console.error(e);
  }
}
function request<T = any> (options: RequestOptionConfig): RequestPromise<T> {
  if(!options) {
    console.error('Request options is missing!');
    return new Promise<RequestResult<T>>((resolve, reject) => reject('Request options is missing!'));
  }
  
  const time = Date.now();
  let keyData = options.data;
  let noKeys = false;
  let returnSourceData = options?.returnSourceData || false;
  switch(Object.prototype.toString.call(options.data)) {
    case '[object String]':
    case '[object Number]':
      break;
    case '[object Object]':
    case '[object Array]':
    case '[object Undefined]':
        keyData = JSON.stringify(options.data) || '';
      break;
    default:
      noKeys = true;
      break;
  }
  let cacheRequestKey = noKeys ? '' : getRequestCacheKey({ ...options, data: keyData });
  // 在 options 中缓存key，用于接口返回时判断，避免由于axios中间件复写参数导致前后key不一致问题
  options.cacheRequestKey = cacheRequestKey;
  let first = false;
  let timeKey = time;
  if (cacheRequestKey) {
    if (cacheRequestKey && cache[cacheRequestKey]) {
      if (time - cache[cacheRequestKey].time > request.cacheTimeout) {
        cache[cacheRequestKey].time = time;
        cache[cacheRequestKey][time] = {
          time,
          queue: [],
          total: 0,
        };
        first = true;
      } else {
        timeKey = cache[cacheRequestKey].time;
      }
    } else if (request.cacheTimeout) {
      cache[cacheRequestKey] = {
        time,
        [time]:{
          time,
          queue: [],
          total: 0,
        }
      };
      first = true;
    }
  }

  // 处理特殊参数需要拼到 headers 上
  let headers: AnyObj = {};
  const handleEbid = (params?: any) => {
    if (params && typeof params === 'object') {
      Object.values(params).forEach(value => {
        if (typeof value === 'string') {
          const matched = value.match(/^ebid_(.+)/);
          if (matched) {
            headers['ebBusinessId'] = matched[1];
          }
        }
      });
    }
  }
  // 处理 params 和 data 参数
  handleEbid(options.params);
  handleEbid(options.data);

  options.headers = { ...headers, ...options.headers || {} }

  const hook = getSyncHook('weappUtils', 'beforeRequestPromise');
  if (hook && typeof hook === 'function') {
    const result = hook(options);
    if (result?.then && typeof result.then === 'function') {
      return result;
    }
  }

  return new Promise<RequestResult<T>>((resolve, reject) => {
    const doRequest = (innerResolve: any, innerReject: any, skipSensitiveScan?: boolean) => {
      if (options.url && !options.baseURL) {
        // let name: string = '';
        // let matchUrl: any;
        // if (matchUrl = options.url.match(/^\/api\/app\/bs\/[^\/]+/)) { // eslint-disable-line
        //   name = matchUrl[0].replace(/^\/api\/app\/bs\//, () => ''); // eslint-disable-line
        // } else if (matchUrl = options.url.match(/^\/api\/bs\/[^\/]+/)){ // eslint-disable-line
        //   name = matchUrl[0].replace(/^\/api\/bs\//, () => ''); // eslint-disable-line
        // }  else if (matchUrl = options.url.match(/^\/api\/app\/[^\/]+/)){ // eslint-disable-line
        //   name = matchUrl[0].replace(/^\/api\/app\//, () => ''); // eslint-disable-line
        // } else if (matchUrl = options.url.match(/^\/api\/[^\/]+/)) { // eslint-disable-line
        //   name = matchUrl[0].replace(/^\/api\//, () => ''); // eslint-disable-line
        // }
        // const baseURL: string = window[`apiUrlweapp${name}`] || axios.defaults.baseURL; // 处理二级路径
        // const baseDomain: string = window[`apiDomainweapp${name}`] || window['publicDomainapi'] || ''; // 处理二级域名
        // options.baseURL = `${baseDomain}${baseURL}`;
        options.baseURL = getBaseUrl(options.url) || window.publicUrlapi || window.publicUrl || '';
        const name = getNameFromUrl(options.url);
        let publicUrlstatic =  window[`publicUrlweapp${name}`] || window.publicUrlstatic || window.publicUrl || ''
        let publicUrlapi = window[`apiUrlweapp${name}`] || window.publicUrlapi || window.publicUrl || '';
        // 请求携带后端api变量的时候 过滤 baseUrl
        if(publicUrlapi){
          const reg = new RegExp(`^${publicUrlapi}`);
          if(options.url.match(reg)){
            options.baseURL = '';
          }
        }
        // 请求前端静态资源 已经默认携带前端二级路径变量的情况下 需要过滤baseUrl
        if(publicUrlstatic){
          const reg = new RegExp(`^${publicUrlstatic}`);
          if(options.url.match(reg)){
            options.baseURL = '';
          }
        }
      }
      // 重复请求合并和取消
      if (cache[cacheRequestKey] && first !== true) {
        if (cache[cacheRequestKey][timeKey]) {
          cache[cacheRequestKey][timeKey].queue.push({ resolve, reject });
          cache[cacheRequestKey][timeKey].total ++;
          return;
        }
      }
  
      /* ----------------------- 敏感词 ----------------------- */
      if (skipSensitiveScan) {
        options = replaceSensitiveData(options);
      }

      const sessionTraceIdData: AnyObj = {
        startTime: new Date().getTime(),
        requestUrl: options.url,
      }

      // 发起请求
      axios(options).then((res: AxiosResponse<RequestResult<T>> ) => {
        sessionTraceIdData.traceId = res?.headers?.traceid;
        sessionTraceIdData.endTime = new Date().getTime();
        const responseType = res.request.responseType || 'json';
        const responseStatus = res.status;
        
        //单体环境登录后页面eteamid超时get接口302返回登录页处理
        // @ts-ignore
        if (window.TEAMS?.currentUser && options?.method === 'get' && res?.data && typeof res.data === 'string' && res.data.indexOf('<div id="root" data-tag="e10-login-weapp-passportweb"></div>') !== -1){
          doLogout();
          return;
        }

        if (responseType === 'json') {
          const { code, status, _securityIntercept_, result, devOpsUrl, msg, data } = res.data;
          // 业务的 code
          if(!status || code < 200 || code >= 400) {
            if (options.url && isShowErrMsg(options.url)) {
              !options.customHandleError && errMessage(msg);
            }
            if (code) {
              // 增加接口错误上报
              // console?.error?.('--monitor-apiError--', res, `${options.url} ${msg}`);
              if (typeof options.url === 'string' && !/front\/monitor\/report\/reportSubData/.test(options.url)) { // 监控的接口错误不上报
                weappMonitorInstance.addTask('error', {
                  type: 'api',
                  message: msg || `${options.url}请求${code}`,
                  fileName: options.url,
                  status,
                  code
                });
              }
            }
          }

          // 有些非标准接口不返回status 所以不能以status作为判断依据
          if (code && code !== 200) {
            saveRequestInfo(sessionTraceIdData, 'error');
          }

          if (_securityIntercept_ === 'intercept') {
            const errMsg = `${msg}\n请求地址:${options.url},请求时间:${new Date().toLocaleString()}`;
            errMessage(errMsg);
            console.error(errMsg);
          }
          /* lisence 错误静默处理，不再拦截渲染 */
          // if (String(code) === '20211217' && result === false) {
          //   handleLisenceError(msg, devOpsUrl);
          // }

          /* ----------------------- 敏感词 ----------------------- */
          const { pass: sensitivePass } = doSensitiveScan(data, {
            onOk: (superviseType: string) => {
              if (superviseType === 'weak') { // 弱控发起请求
                doRequest(innerResolve, innerReject, superviseType === 'weak')
              } else { // 强控直接关闭
                if (returnSourceData) {
                  innerReject(res);
                } else {
                  innerReject(res.data);
                }
              }
            },
            onCancel: () => {
              if (returnSourceData) {
                return innerReject(res);
              } else {
                return innerReject(res.data);
              }
            },
          }, skipSensitiveScan);
          
          if (sensitivePass) {
            if (returnSourceData) {
              innerResolve(res);
            } else {
              innerResolve(res.data);
            }
            const cacheRequestKey = (res.config as RequestOptionConfig).cacheRequestKey;
            if (cacheRequestKey) {
              clearCacheQueue(cacheRequestKey, res, 'resolve', options, time);
            }
          }

          // E10第三方APP认证优化: 超时登出，接入ebutils
          if (code === 20220610 && !window.ebAuthChecking) {
            saveRequestInfo(sessionTraceIdData, 'error');
            window.ebAuthChecking = true;
            corsImport('@weapp/ebutils').then((weapp) => {
              const ebutilsApp = weapp.default || weapp;
              if (ebutilsApp && typeof ebutilsApp.ebAuthCheck === 'function') {
                ebutilsApp.ebAuthCheck();
              }
            })
          }
          
          // E10 统一认证跳转
          if (code === 20221104 && !window.intAuthChecking) {
            saveRequestInfo(sessionTraceIdData, 'error');
            window.intAuthChecking = true;
            const url = (data as any)?.loginurl;
            url && weappSDK.webOpen(url);
          }
          
          saveRequestInfo(sessionTraceIdData, "success");
        } else {
          saveRequestInfo(sessionTraceIdData, "success");
          if (returnSourceData) {
            innerResolve(res);
          } else {
            innerResolve(res.data);
          }
          const cacheRequestKey = (res.config as RequestOptionConfig).cacheRequestKey;
          if (cacheRequestKey) {
            clearCacheQueue(cacheRequestKey, res, 'resolve', options, time);
          }
        }
      }).catch((err: AxiosError<RequestResult<T>>) => {
        if (err) {
          if (err.response) {
            if (err.response.status === 401 && err.response.data?.code === -1) {
              doLogout();
            }
            err.message = getErrMessage(err.response);
            // 增加接口错误上报
            // console?.error?.('--monitor-apiError--', err);
            if (typeof options.url === 'string' && !/front\/monitor\/report\/reportSubData/.test(options.url)) { // 监控的接口错误不上报
              weappMonitorInstance.addTask('error', {
                type: 'api',
                message: err.message || `${options.url}请求${err.response.data?.code || '失败'}`,
                fileName: options.url,
                status: err.response.status,
                code: err.response.data?.code || 0,
              });
            }
            console.error(`${options.url} ${err.response.status} ${err.response.headers?.tracecode || ''} ${err.response.headers?.traceid || ''} ${err.message}`);
            sessionTraceIdData.traceId = err.response.headers?.traceid;
            sessionTraceIdData.endTime = new Date().getTime();
            saveRequestInfo(sessionTraceIdData, 'error');
          }
          if (err.config) {
            const cacheRequestKey = (err.config as RequestOptionConfig).cacheRequestKey;
            if (cacheRequestKey) {
              clearCacheQueue(cacheRequestKey, err, 'reject', options, time);
            }
          }
        }
        // 代码错误不再弹框，直接控制台抛错
        return innerReject(err);
      });
    }
    if (!window.ebAuthChecking) doRequest(resolve, reject);
  })
}

function config(key: string, value: any) {
  // 配置需要显示错误提示信息的模块
  if (key === 'showErrMsgModules') {
    const preVal = window.localStorage?.getItem(key) || '';
    const defaultShowErrMsgModules = (preVal ? preVal.split(',') : []).concat(showErrMsgModules);
    const preSet = new Set(defaultShowErrMsgModules);
    if (typeof value === 'string') {
      preSet.add(value);
    } else if (Array.isArray(value)) {
      value?.forEach((val) => preSet.add(val));
    }
    window.localStorage?.setItem(key, `${Array.from(preSet).join(',')}`);
  }
}

function saveRequestInfo(data: AnyObj, type: "success" | "error") {
  const { traceId } = data;
  if (traceId) {
    data.requestUrl = data.requestUrl.split("?")[0];
    sessionTraceId(data, type);
  }
}

// 重复请求缓存配置
request.cacheTimeout = 500;
request.cache = cache;
request.config = config;

export const qs = q;

export default request;
